module.exports = __webpack_public_path__ + "img/bg-light.8383f6e1.png";